import {
  IDeductionRepository,
  IGetAccountingDataRepositoryParams,
  IGetAccountingDataRepositoryResponse,
} from "@/core/repositories/deduction";

export class GetAccountingDataUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(
    params: IGetAccountingDataRepositoryParams,
    refetch?: boolean
  ): Promise<IGetAccountingDataRepositoryResponse> {
    const response = await this.deductionRepository.getAccountingData(params, refetch);

    return response;
  }
}
